export const toggleYear = (value) => {
  return {
    type: "TOGGLE_YEAR",
    payload: value,
  };
};
